


























































































































































































































































































import LocalData from "@/mixins/local-data";
import {Component, Mixins, Watch} from "vue-property-decorator";
import Http from "../../mixins/http";
import Toast from "../../mixins/toast";
import CollapseCard from "@/components/UI/CollapseCard.vue";
import CompetitorsDirectory from "@/components/MonitoringPrice/CompetitorsDirectory.vue";
import CompetitorsPrice from "@/components/MonitoringPrice/CompetitorsPrice.vue";
import ParsingProducts from "@/components/MonitoringPrice/ParsingProducts.vue";
import ParsingSettings from "@/components/MonitoringPrice/ParsingSettings.vue";
import {SelectMarket} from "@/interfaces/global-data";
import MarketSelect from "@/components/MarketSelect.vue";
import ParsingResults from "./ParsingResults.vue";

interface commonFilters {
	groups: [];
	categories: [];
	subcategories: [];
	storeFormat: [];
	storeRegion: [];
	storeCluster: [];
}

@Component({
	components: {
		MarketSelect,
		CompetitorsDirectory,
		CompetitorsPrice,
		CollapseCard,
		ParsingProducts,
		ParsingSettings,
		ParsingResults,
	},
})
export default class MonitoringPrice extends Mixins(Http, Toast, LocalData) {
	currentMainTab: string = "competitorsDirectory";
	currentMarket: SelectMarket | null = null;
	commonFilters = {
		groups: [],
		categories: [],
		subcategories: [],
		storeFormat: [],
		storeRegion: [],
		storeCluster: [],
	};
	commonFiltersSelected = {
		groups: ["all"],
		categories: ["all"],
		subcategories: ["all"],
		storeFormat: ["all"],
		storeRegion: ["all"],
		storeCluster: ["all"],
	};

    parsingProductsKey: string = 'parsingProductsKey';
    parsingSettingsKey: string = 'parsingSettingsKey';
    parsingResultsKey: string = 'parsingResultsKey';

	get commonFiltersProps() {
		const self = this;
		return Object.keys(this.commonFilters).reduce((result: Record<string, any>, key) => {
			const typedKey = key as keyof typeof self.commonFiltersSelected;
			const items = self.commonFilters[typedKey] || [];

			result[typedKey] = items.map((item: any) => ({
				...item,
				label: item.name,
				value: item.id || null,
				isSelected: self.commonFiltersSelected[typedKey].includes(item.id || null) || false,
			}));

			result[typedKey].forEach((item: any) => {
				delete item.name;
			});

			return result;
		}, {});
	}

	// ФУКНЦИИ ОБРАБОТКИ ИТЕРАЦИЙ
	handleTabClick(key: string) {
		this.currentMainTab = key;

        if (key === "parsingProducts") {
            if (this.$refs.parsingProductsRef) {
                (this.$refs.parsingProductsRef as any).fetchCompetitorLinkedProducts();
                (this.$refs.parsingProductsRef as any).fetchCompetitorLinkedProductsTableOptions();
            }
        } else if (key === "parsingSettings") {
            if (this.$refs.parsingSettingsRef) {
                (this.$refs.parsingSettingsRef as any).fetchParsingConfigs();
                (this.$refs.parsingSettingsRef as any).fetchParsingConfigsTableOptions();
            }
        } else if (key === "parsingResults") {
            if (this.$refs.parsingResultsRef) {
                (this.$refs.parsingResultsRef as any).fetchParsingResultsData();
                (this.$refs.parsingResultsRef as any).fetchParsingResultsTableOptions();
            }
        }
	}

	handleFilterMarket(market: SelectMarket) {
		this.currentMarket = market;
		localStorage.setItem("compDirectoryMarket", JSON.stringify(market));
	}

	handleLocalStorageSet(key: string, data: any) {
		localStorage.setItem(key, JSON.stringify(data));
	}

	// ФИЛЬТРЫ КАТЕГОРИЙ ТОВАРОВ
	async handleFilterGroup(elemids: any) {
		this.commonFiltersSelected.groups = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
		this.commonFiltersSelected.categories = ["all"];
		this.commonFiltersSelected.subcategories = ["all"];

		await this.requestCommonFilter("category", "categories");
	}

	async handleFilterCategory(elemids: any) {
		this.commonFiltersSelected.categories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
		this.commonFiltersSelected.subcategories = ["all"];

		await this.requestCommonFilter("subcategory", "subcategories");
	}

	async handleFilterSubcategory(elemids: any) {
		this.commonFiltersSelected.subcategories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
	}

    handleResetShopLevelsFilters() {
        this.commonFiltersSelected.storeFormat = ['all'];
        this.commonFiltersSelected.storeRegion = ['all'];
        this.commonFiltersSelected.storeCluster = ['all'];
    }

	// ФИЛЬТРЫ УРОВНЕЙ МАГАЗИНОВ
	async handleFilterFormat(elemids: any) {
		this.commonFiltersSelected.storeFormat = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
		this.commonFiltersSelected.storeRegion = ["all"];
		this.commonFiltersSelected.storeCluster = ["all"];

		await this.requestCommonFilter("region", "storeRegion");
		await this.requestCommonFilter("cluster", "storeCluster");
	}

	async handleFilterRegion(elemids: any) {
		this.commonFiltersSelected.storeRegion = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
		this.commonFiltersSelected.storeCluster = ["all"];

		await this.requestCommonFilter("cluster", "storeCluster");
	}

	async handleFilterCluster(elemids: any) {
		this.commonFiltersSelected.storeCluster = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
	}

	async handleFilterApply() {
		await this.handleLocalStorageSet("compDirectoryFilters", this.commonFiltersSelected);

		if (this.currentMainTab === "competitorsDirectory") {
			this.requestCompsDirectory();
		}
		if (this.currentMainTab === "competitorsPrice") {
			this.requestCompsPrices();
		}
	}

	async handleMarketApply() {
		this.commonFiltersSelected.groups = ["all"];
		this.commonFiltersSelected.categories = ["all"];
		this.commonFiltersSelected.subcategories = ["all"];
		this.commonFiltersSelected.storeFormat = ["all"];
		this.commonFiltersSelected.storeRegion = ["all"];
		this.commonFiltersSelected.storeCluster = ["all"];
		localStorage.removeItem("compDirectoryFilters");

		await this.requestCommonFilter("group", "groups");
		await this.requestCommonFilter("format", "storeFormat");
		await this.requestCommonFilter("region", "storeRegion");
		await this.requestCommonFilter("cluster", "storeCluster");
		await this.requestCompsDirectory();
		await this.requestCompsPrices();

        this.rerenderParsingTabsContent();

		this.showInfo(this.$t('shared.messages.tradingCompanyChanged') as string);
	}

    rerenderParsingTabsContent() {
        const uniqValue: number = Number(new Date());

        if (this.$refs.parsingProductsRef) {
            this.parsingProductsKey = `parsingProductsKey_${uniqValue}`;

            (this.$refs.parsingProductsRef as any).$forceUpdate();
        }

        if (this.$refs.parsingSettingsRef) {
            this.parsingSettingsKey = `parsingSettingsKey_${uniqValue}`;

            (this.$refs.parsingSettingsRef as any).$forceUpdate();
        }

        if (this.$refs.parsingResultsRef) {
            this.parsingResultsKey = `parsingResultsKey_${uniqValue}`;

            (this.$refs.parsingResultsRef as any).$forceUpdate();
        }
    }

	async localStorageGet() {
		try {
			const item = localStorage.getItem("compDirectoryFilters");
			const self = this;
			let filters: Record<string, any> = item ? JSON.parse(item) : null;

			const filterkeys: {
				storeRegion: string;
				storeCluster: string;
				storeFormat: string;
				groups: string;
				categories: string;
				subcategories: string;
			} = {
				storeRegion: "region",
				storeCluster: "cluster",
				storeFormat: "format",
				groups: "group",
				categories: "category",
				subcategories: "subcategory",
			};

			if (filters !== null) {
				for (const key in filters) {
					if (key in filterkeys) {
						const filterValue = filters[key];

						if (key in self.commonFiltersSelected) {
							self.commonFiltersSelected[key as keyof typeof self.commonFiltersSelected] = filterValue;
						}

						if (Array.isArray(filterValue) && filterValue.length && filterValue[0] !== "all") {
							if (key === "storeFormat") {
								await self.requestCommonFilter("region", "storeRegion");
							}
							if (key === "storeRegion") {
								await self.requestCommonFilter("cluster", "storeCluster");
							}
							if (key === "groups") {
								await self.requestCommonFilter("category", "categories");
							}
							if (key === "categories") {
								await self.requestCommonFilter("subcategory", "subcategories");
							}
						}
					}
				}
			}
		} catch (error) {
			console.error(error);
		} finally {
			this.requestCompsDirectory();
			this.requestCompsPrices();
		}
	}

	// ФУНКЦИИ НА ЗАПРОСЫ
	async requestCommonFilter(filterBy: string, keyToChange: keyof commonFilters) {
		let obj = {
			groups: this.commonFiltersSelected.groups.filter((item) => item !== "all"),
			categories: this.commonFiltersSelected.categories.filter((item) => item !== "all"),
			subcategories: this.commonFiltersSelected.subcategories.filter((item) => item !== "all"),
			storeFormat: this.commonFiltersSelected.storeFormat.filter((item) => item !== "all"),
			storeRegion: this.commonFiltersSelected.storeRegion.filter((item) => item !== "all"),
			storeCluster: this.commonFiltersSelected.storeCluster.filter((item) => item !== "all"),
			tradingId: this.currentMarket ? this.currentMarket.id : 157,
			type: filterBy,
		};

		try {
			const response = await this.$http.post("/api/task/info", obj);
			this.commonFilters[keyToChange] = response.data[keyToChange];
		} catch (error) {
			console.error("Error sending POST request:", error);
		}
	}

	async requestCompsDirectory() {
		if (this.currentMainTab === "competitorsDirectory") {
			(this.$refs.compsdirectory as CompetitorsDirectory).fetchTableData();
		}
	}

	async requestCompsPrices() {
		if (this.currentMainTab === "competitorsPrice") {
			(this.$refs.compsprice as CompetitorsPrice).fetchTableData();
		}
	}

	setMarketSelect() {
		let marketFromLocal = localStorage.getItem("compDirectoryMarket");

		if (marketFromLocal) {
			this.currentMarket = JSON.parse(marketFromLocal);
		} else {
			this.currentMarket = null;
		}

		localStorage.getItem("compDirectoryMarket") ? (JSON.parse(localStorage.getItem("compDirectoryMarket") as string) as SelectMarket) : (null as SelectMarket | null);
	}

	async mounted() {
		await this.setMarketSelect();
		await this.requestCommonFilter("group", "groups");
		await this.requestCommonFilter("format", "storeFormat");
		await this.requestCommonFilter("region", "storeRegion");
		await this.requestCommonFilter("cluster", "storeCluster");
		await this.localStorageGet();
	}

	updateFilterArray(filterArray: (string | number)[]) {
		if (filterArray.length === 0) {
			filterArray.push("all");
		} else if (filterArray.includes("all") && filterArray.length > 1) {
			filterArray.splice(filterArray.indexOf("all"), 1);
		}
	}

	@Watch("commonFiltersSelected", {deep: true})
	onCommonFiltersSelectedChange() {
		const self = this;
		Object.keys(self.commonFiltersSelected).forEach((key) => {
			const filterArray = self.commonFiltersSelected[key as keyof commonFilters];
			this.updateFilterArray(filterArray);
		});
	}

    filterOption(input: string, option: any) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
}
